import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const raw = localStorage.getItem("relatemetrics_user") || localStorage.getItem("attune_user");
  if (raw) {
    const u = JSON.parse(raw);
    if (u?.token) config.headers.Authorization = `Bearer ${u.token}`;
  }
  return config;
});

export const api = {
  base: API,
  countries: () => client.get("/countries").then((r) => r.data.countries),
  pricing: (country) => client.get(`/pricing?country=${country}`).then((r) => r.data),
  questions: () => client.get("/questions").then((r) => r.data),
  createUser: (body) => client.post("/users", body).then((r) => r.data),
  me: () => client.get("/me").then((r) => r.data),
  checkout: (purpose) => client.post("/checkout", { purpose }).then((r) => r.data),
  confirm: (order_id, payload = {}) =>
    client.post("/checkout/confirm", { order_id, payload }).then((r) => r.data),
  submit: (answers, invite_token) =>
    client.post("/assessments/submit", { answers, invite_token }).then((r) => r.data),
  report: (id) => client.get(`/reports/${id}`).then((r) => r.data),
  reportPdf: (id) => `${API}/reports/${id}/pdf`,
  combination: (id) => client.get(`/combination/${id}`).then((r) => r.data),
  combinationPdf: (id) => `${API}/combination/${id}/pdf`,
  createInvite: (body) => client.post("/invites", body).then((r) => r.data),
  getInvite: (token) => client.get(`/invites/${token}`).then((r) => r.data),
  startInvite: (token, body) =>
    client.post(`/invites/${token}/start`, body).then((r) => r.data),
  ebook: () => client.get("/ebook").then((r) => r.data),
  ebookPdf: () => `${API}/ebook/pdf`,
  listTeams: () => client.get("/teams").then((r) => r.data.teams),
  createTeam: (name) => client.post("/teams", { name }).then((r) => r.data.team),
  getTeam: (id) => client.get(`/teams/${id}`).then((r) => r.data.team),
  inviteTeam: (id, body) => client.post(`/teams/${id}/invite`, body).then((r) => r.data.invite),
  refreshTeam: (id) => client.post(`/teams/${id}/refresh`).then((r) => r.data),
  getTeamInvite: (token) => client.get(`/team-invites/${token}`).then((r) => r.data),
  setReminderDays: (id, reminder_days) =>
    client.post(`/teams/${id}/reminder-settings`, { reminder_days }).then((r) => r.data),
  contact: (body) => client.post("/contact", body).then((r) => r.data),
  downloadTeamPdf: async (id) => {
    const r = await client.get(`/teams/${id}/pdf`, { responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    window.open(url, "_blank");
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  },
};

export default client;
